import { API, graphqlOperation } from 'aws-amplify';
import * as subscriptions from '../graphql/subscriptions';

const subscribeMixin = {
  methods: {
    subscribeAndInvoke(events, toInvoke) {
      Object.keys(subscriptions).forEach((item) => {
        if (events.indexOf(item) !== -1) {
          API.graphql(
            graphqlOperation(subscriptions[item]),
          ).subscribe({
            next: () => {
              toInvoke();
            },
          });
        }
      });
    },
  },
};

export default subscribeMixin;
